import { GetOrderResponseDataOrderEligibilitiesEligibilityLevel } from 'src/sdk-servicing';

/**
 * Change Journey可否を取得する
 * @param eligibilityLevel
 * @returns true 可 / false 不可
 */
export function canChangeJourney(eligibilityLevel?: GetOrderResponseDataOrderEligibilitiesEligibilityLevel): boolean {
  let can = false;

  if (eligibilityLevel?.level === GetOrderResponseDataOrderEligibilitiesEligibilityLevel.LevelEnum._3) {
    can = true;
  } else {
    const restrictedReasons = eligibilityLevel?.restrictedReasons;

    if (
      restrictedReasons?.length === 1 &&
      restrictedReasons[0] ===
        GetOrderResponseDataOrderEligibilitiesEligibilityLevel.RestrictedReasonsEnum.CurrencyDiscrepancy
    ) {
      can = true;
    }
  }

  return can;
}
